/**
 * @module app.cd
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getClientDataQuestionTypes(): DynamicViews {
    return {
        'CD.BMI':
            [{ title: 'BMI', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-bmi') }]
    };
}
